import { useMemo } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

import { useEditCanvasStore } from '../../store';
import { canGroupSelection } from '../../utils/group/nodeGrouping';
import { useGroupActions } from '../group/useGroupActions';
import { useIsGroupSelection } from '../group/useIsGroupSelection';
import { useIsMultiSelected } from '../useIsMultiSelected';
import { useSelectedCanvasNodes } from '../useSelectedCanvasNodes';

export function useGroupShortcuts() {
  const selectedNodes = useSelectedCanvasNodes();
  const readOnly = useEditCanvasStore((s) => s.readOnly);
  const isMultiSelected = useIsMultiSelected();
  const isGroupSelection = useIsGroupSelection();
  const { handleGroup, handleUngroup } = useGroupActions();

  const canGroup = useMemo(() => canGroupSelection(selectedNodes), [selectedNodes]);

  const groupOptions = useMemo(
    () => ({ enabled: isMultiSelected && !readOnly && canGroup, preventDefault: true }),
    [isMultiSelected, readOnly, canGroup],
  );

  const ungroupOptions = useMemo(
    () => ({ enabled: isGroupSelection && !readOnly, preventDefault: true }),
    [isGroupSelection, readOnly],
  );

  useHotkeys('meta+g,ctrl+g', handleGroup, groupOptions, [handleGroup, groupOptions]);
  useHotkeys('meta+shift+g,ctrl+shift+g', handleUngroup, ungroupOptions, [handleUngroup, ungroupOptions]);
}
